import React from 'react';
class Ad extends React.Component {
    constructor(props) {
        super(props);
        this.adSlots = [
            '',
            'responsive_1',
            'responsive_2',
            'responsive_3',
            'responsive_4',
            'responsive_5',
            'responsive_6',
            'responsive_7',
            'responsive_8'
        ];
    }

    render() {
        return (
            <div className={`display-ad display_${this.props.nbr}`}>
                <div className={`${this.props.fitAdsToContent ? 'adunit-wrapper-fit_to_content ' : ''}adunit-wrapper d-flex flex-column align-items-center full-width-breakout`}>
                    <div id={`${this.adSlots[this.props.nbr]}-${this.props.timestamp}`}
                        className="adunit"
                        count={this.props.nbr}
                        data-aller-ad-placement={`responsive_${this.props.nbr}`}
                        data-aduniqueid={this.props.timestamp}>
                    </div>
                </div>
            </div>
        );
    }
}
export default Ad;
